import { render, staticRenderFns } from "./BucketAdminConfiguration.vue?vue&type=template&id=7ad0e530&scoped=true&"
import script from "./BucketAdminConfiguration.vue?vue&type=script&lang=js&"
export * from "./BucketAdminConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad0e530",
  null
  
)

export default component.exports